import { render, staticRenderFns } from "./InboxQualitySettings.vue?vue&type=template&id=6fcc78f4&scoped=true&"
import script from "./InboxQualitySettings.vue?vue&type=script&lang=js&"
export * from "./InboxQualitySettings.vue?vue&type=script&lang=js&"
import style0 from "./InboxQualitySettings.vue?vue&type=style&index=0&id=6fcc78f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcc78f4",
  null
  
)

export default component.exports